'use strict';

$.fn.extend({
  prettifyBigUrls: function () {
    return this.each(function () {
      var content, lastPart, middle, newContent, obj, splitted;
      obj = $(this);
      content = obj.text();
      splitted = content.split('/');
      if (splitted.length > 1) {
        lastPart = splitted.pop();
        middle = splitted.join('/');
        newContent =
          '<span class="url-middle-crop">' + middle + '</span>' +
          '<span class="url-crop-rest">/' + lastPart + '</span>';
        return obj.replaceWith($(newContent));
      }
    });
  }
});

function prettifyUrlInReviewLists () {
  return $('.criterium .part')
    .find('.cropable-url, .underscore-url')
    .prettifyBigUrls();
}

module.exports = prettifyUrlInReviewLists;
